module.exports = __webpack_public_path__ + "media/images/lb/112-e83966b4a3a38d2a6f84b6afa4a614d4.svg";